import Contact from "../components/candidate/Contact";
import RecNavbar from "../components/recruiter/RecHomeNavbar";

export default function CandidateProfile() {
  return (
    <>
      <RecNavbar />
      <Contact />
    </>
  );
}